module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv-sp-0ab0b5f8b9b2ee0ede495bf8ce6a79ea.jpg";